// extracted by mini-css-extract-plugin
export default {"develop":"page-in-develop_develop__WzR2M","text":"page-in-develop_text__MkUDG","button":"page-in-develop_button__VnYNF"};